export default {"src":"/_next/static/media/ico_next.ec5b96a1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};